import {isWithinDaysFromNow, isWithinYearsFromNow, formatDate} from '../DateUtil'

export default function Enrollment (props) {
  const now = new Date()
  // calculate status on shopper
  let status;
  if (props.role != 'student' && !props.disabled_at) {
    status = 'ready'
  } else if (props.extension) {
    status = 'extension'
  } else if (props.disabled_at) {
    status = 'disabled'
  } else if (props.transferred_to) {
    status = 'transferred'
  } else if (!props.assigned_to) {
    status = 'not_assigned'
  } else if (props.enrollment_type == "timed" && !!props.assigned_to && !props.end_at) {
    status = 'delayed_start'
  } else if (props.enrollment_type == "section" && props.section_start_at && new Date(props.section_start_at) > now) {
    status = 'section_not_started'
  } else if (props.enrollment_type == "section" && props.section_end_at && new Date(props.section_end_at) < now) {
    status = 'section_ended'
  } else if (props.end_at && new Date(props.end_at) < now) {
    status = 'expired'
  } else {
    status = 'ready'
  }

  const self = {
    belongsToOther: (user) => !user.is(props.owner) && !user.is(props.assigned_to),
    ownedByOther: (user) => props.owner != user.username,
    ownedByUser: (user) => props.owner == user.username,
    observedBy: props.observed_by,
    status: status,
    isTemp: !!props.temp_access,
    isFreeTrial: props.access_length == 14 && props.access_unit == 'day' && !props.temp_access,
    isRetaken: !!props.retaken_section_name,
    isNotAssigned: !props.assigned_to,
    isAssignedToUser: (user) => !!props.assigned_to && user.is(props.assigned_to),
    isAssignedToOther: (user) => !!props.assigned_to && !user.is(props.assigned_to),
    isOfficeHour: !!props.is_office_hour,
    isRoleTeacher: props.role == 'teacher',
    isRoleStudent: props.role == 'student',
    isDeactivated: !!props.disabled_at,
    endAt: formatDate(props.end_at),
    startAt: formatDate(props.start_at),
    sectionStartAt: formatDate(props.section_start_at),
    createdAt: props.created_at,
    startAtDate: props.start_at && new Date(props.start_at),
    sectionStartAtDate: props.section_start_at && new Date(props.section_start_at),
    isAssigned: !!props.assigned_to,
    isPrevious: ["expired", "section_ended", "disabled"].indexOf(status) != -1,
    isClassroom: props.organization_public_registration,
    isUserAssignedRegistration: props.organization_user_assigned_registration,
    extensible: props.allow_extension && ["ready", "section_ended", "expired"].indexOf(status) != -1
  }

  if (!!props.organization_name) {
    if (props.enrollment_type == 'section') {
      self.title = `${props.organization_name} - ${props.course_name} - ${props.section_name}`
    } else {
      self.title = `${props.organization_name} - ${props.course_name}`
    }
  }

  self.isActive = !self.isPrevious;

  return Object.assign({}, props, self)
}
